/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { IResource } from '@opentelemetry/resources';
import type { HrTime, SpanContext } from '@opentelemetry/api';
import type { InstrumentationScope } from '@opentelemetry/core';
import type {
  LogBody,
  LogAttributes,
  SeverityNumber,
} from '@opentelemetry/api-logs';

export interface ReadableLogRecord {
  readonly hrTime: HrTime;
  readonly hrTimeObserved: HrTime;
  readonly spanContext?: SpanContext;
  readonly severityText?: string;
  readonly severityNumber?: SeverityNumber;
  readonly body?: LogBody;
  readonly resource: IResource;
  readonly instrumentationScope: InstrumentationScope;
  readonly attributes: LogAttributes;
  readonly droppedAttributesCount: number;
}
